import { render } from "./AutoReadingLogged.vue?vue&type=template&id=3823dd3d&scoped=true"
import script from "./AutoReadingLogged.vue?vue&type=script&lang=js"
export * from "./AutoReadingLogged.vue?vue&type=script&lang=js"

import "./AutoReadingLogged.vue?vue&type=style&index=0&id=3823dd3d&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3823dd3d"]])

export default __exports__